/**
 * Menu icons copied from the live reference theme-icon set.
 * https://img.m167cw.com/mcw/h5/assets/images/icon-set/theme-icon/
 * Contact art is the reference customer-service images. Color for the
 * SVG masks comes from CSS, the same way the reference paints them.
 */
import home from './icon-home.svg';
import login from './icon-login.svg';
import register from './icon-register.svg';
import search from './icon-search.svg';
import close from './icon-close.svg';
import promotion from './icon-promotion.svg';
import winnerBoard from './icon-winner-board.svg';
import vip from './icon-vip.svg';
import download from './icon-download.svg';
import affiliate from './icon-affiliate.svg';
import partnership from './icon-partnership.svg';
import headCoin from './head-coin.png';
import cs from './icon-cs.png';
import telegram from './icon-telegram.png';
import email from './icon-email.png';
import { CATEGORY_ICON_SRC } from '../category-icons/index.js';

export const MENU_ICON_SRC = {
  home,
  login,
  register,
  search,
  close,
  headCoin,
  cs,
  telegram,
  email,
  hot: CATEGORY_ICON_SRC.hot,
  sports: CATEGORY_ICON_SRC.sports,
  casino: CATEGORY_ICON_SRC.casino,
  slots: CATEGORY_ICON_SRC.slots,
  crash: CATEGORY_ICON_SRC.crash,
  table: CATEGORY_ICON_SRC.table,
  fishing: CATEGORY_ICON_SRC.fishing,
  arcade: CATEGORY_ICON_SRC.arcade,
  lottery: CATEGORY_ICON_SRC.lottery,
  promotion,
  winnerBoard,
  vip,
  download,
  affiliate,
  partnership,
};

/** Reference menu category order and the labels measured on /bd/en. */
export const REF_MENU_CAT_ORDER = [
  'hot',
  'sports',
  'casino',
  'slots',
  'crash',
  'table',
  'fishing',
  'arcade',
  'lottery',
];

export const REF_MENU_CAT_LABELS = {
  hot: 'HOT',
  sports: 'Sports',
  casino: 'Casino',
  slots: 'Slot',
  crash: 'Crash',
  table: 'Table',
  fishing: 'Fishing',
  arcade: 'Arcade',
  lottery: 'Lottery',
};
